const rejectedTokenCodes = [40, 41, 42, 43];

export function isRejectedTokenError(error: unknown): boolean {
    if (!(error instanceof Error)) {
        return false;
    }

    if (error.message.includes('userToken does not have a user_id or is not matching with user.id')) {
        return true;
    }

    let parsed: unknown;
    try {
        parsed = JSON.parse(error.message);
    } catch {
        return false;
    }

    if (!parsed || typeof parsed !== 'object') {
        return false;
    }

    const body = parsed as { code?: unknown; StatusCode?: unknown; isWSFailure?: unknown };
    // Transport failures reuse this JSON shape; only an auth rejection should drop the saved session.
    if (body.isWSFailure === true) {
        return false;
    }
    // WS payloads sometimes send these as strings.
    if (Number(body.StatusCode) === 401) {
        return true;
    }
    return rejectedTokenCodes.includes(Number(body.code));
}
